import React from 'react';
import { observer } from 'mobx-react-lite';
import { freeBetStore, useTranslation } from '@pascal/pascal-core';
import { gameConfigStore } from '@pascal/pascal-core/shared/core/store';
import { oddStore } from '../../store/oddStore';
import { doBetStore } from '../../store/doBetStore';

export const FreeBetMaxPayoutPopup = observer(() => {
  const t = useTranslation();
  const pigsInfoOnRound = doBetStore.pigs;
  const { activeFreeBet } = freeBetStore;
  const { limits } = gameConfigStore;

  // eslint-disable-next-line array-callback-return
  return pigsInfoOnRound.map((pig, idx) => {
    const maxPayout = activeFreeBet ? freeBetStore?.activeFreeBet.maxPayout : limits.maxWin;

    return pig.id === idx &&
      pig.betAmount * oddStore.oddData[pig.id] >= maxPayout &&
      pig.isBetAccepted ? (
      <div className='free-bet-popup'>
        <div className='free-bet-popup-content'>
          <div className='free-bet-popup-content-inner'>
            <p className='free-bet-title'>{}</p>
            <div className='min-max-row'>
              <div className='min-max-row-inner' />
              <div className='min-max-row-inner'>
                <p className='max-info'>
                  maxPayout: <span>{maxPayout}</span>
                </p>
              </div>
            </div>
            <p className='date-info'>expiredDateNotification</p>
            {/* <div onClick={() => handleClosePopUp(freeBetId)}> */}
            {/*  /!*<p className='use-txt'>{t(TranslationKeys.UseLater)}</p>*!/ */}
            {/* </div> */}
          </div>
        </div>
      </div>
    ) : null;
  });
});
